import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - One Piece Trivia</title>
        <meta name="description" content="Contact the One Piece Trivia team. Send us feedback, report issues, or just say hello!" />
        <link rel="canonical" href="https://www.onepiecetrivia.com/contact" />
      </Helmet>

      <div className="legal-page-container">
        <div className="legal-page-content contact-page">
          <h1>Contact Us</h1>

          <section>
            <p className="intro-text">
              We'd love to hear from you! Whether you have feedback, found a bug, or just
              want to share your high score, feel free to reach out.
            </p>
          </section>

          <section className="contact-methods">
            <div className="contact-card">
              <h2>General Inquiries</h2>
              <p>For questions about the quiz or website:</p>
              <p className="contact-email">chibidashofficial@gmail.com</p>            </div>

            <div className="contact-card">
              <h2>Bug Reports</h2>
              <p>Found something not working right?</p>
              <p className="contact-email">chibidashofficial@gmail.com</p>            </div>

            <div className="contact-card">
              <h2>Business Inquiries</h2>
              <p>For partnerships and advertising:</p>
              <p className="contact-email">chibidashofficial@gmail.com</p>            </div>
          </section>

          <section>
            <h2>Feedback</h2>
            <p>
              Your feedback helps us improve! Let us know:
            </p>
            <ul>
              <li>Which quiz is your favorite?</li>
              <li>What new features would you like to see?</li>
              <li>Are there any characters or Devil Fruits we should add?</li>
              <li>Did you find any incorrect answers?</li>
            </ul>
          </section>

          <section>
            <h2>Response Time</h2>
            <p>
              We try to respond to all inquiries within 48-72 hours. During busy periods,
              it may take a bit longer. Thank you for your patience!
            </p>
          </section>

          <section>
            <h2>Community</h2>
            <p>
              Join the One Piece fan community and share your quiz results! Challenge your
              friends and see who's the ultimate One Piece expert.
            </p>
          </section>

          <section className="cta-section">
            <p>
              Ready to test your knowledge? <a href="/" className="home-link">Play now!</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Contact;
